import * as React from "react";
// import { pure } from 'recompose'
import * as cx from "classnames";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    maxLength,
    name,
    value,
    onChangeValue,
    disabled,
    autoComplete,
    autoFocus,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <input
      maxLength={maxLength}
      className={cx("span-input", { noBorder: disabled })}
      type="text"
      disabled={disabled}
      name={name}
      value={value}
      onChange={onChangeValue}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
    />
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  maxLength?: any;
  name?: any;
  value?: any;
  onChangeValue?: any;
  disabled?: any;
  autoComplete?: any;
  autoFocus?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/forms/input/text/normal/component.tsx